<div class="w-[1000px]">
  @if (showSearch) {
    <div class="flex justify-between mb-4">
      <div class="w-4/12">
        <h2 class="font-semibold text-lg">{{ title$ | async }}</h2>
      </div>
      <tui-input [formControl]="search" tuiTextfieldSize="s" class="mr-2 w-6/12"
        >Поиск
      </tui-input>
    </div>
  } @else {
    <h2 class="font-semibold text-lg mb-4">{{ title$ | async }}</h2>
  }
  <tui-scrollbar>
    <cdk-virtual-scroll-viewport
      tuiScrollable
      [itemSize]="50"
      [style.height.px]="300"
      [maxBufferPx]="200"
      [minBufferPx]="100"
    >
      <table class="w-full" tuiTable [columns]="columns">
        <thead>
          <tr tuiThGroup>
            <th class="flex justify-center items-center" tuiTh>
              <tui-checkbox
                [ngModel]="isAllSelected$ | async"
                (ngModelChange)="selectAll$.next()"
                size="m"
              ></tui-checkbox>
            </th>
            @for (header of headers; track identity) {
              <th [width]="header.width ?? 'auto'" tuiTh>
                {{ header.name }}
              </th>
            }
          </tr>
        </thead>
        <tbody tuiTbody>
          <tr *cdkVirtualFor="let item of filteredItems$ | async" tuiTr>
            <td *tuiCell="'selected'" tuiTd>
              <div class="flex justify-center items-center h-full">
                <tui-checkbox
                  [ngModel]="isSelected(item)"
                  (ngModelChange)="onSelect(item)"
                  size="m"
                ></tui-checkbox>
              </div>
            </td>
            @for (header of headers; track identity) {
              <td
                [width]="header.width ?? 'auto'"
                *tuiCell="stringify(header.value)"
                tuiTd
              >
                @if (header.component) {
                  <ng-container
                    *polymorpheusOutlet="
                      header.component;
                      context: { $implicit: item[header.value] }
                    "
                  ></ng-container>
                } @else {
                  <tui-line-clamp
                    [lineHeight]="19"
                    [linesLimit]="1"
                    [content]="
                      header.isDate
                        ? (item[header.value] | date: 'dd.MM.YYYY')
                        : item[header.value]
                    "
                  ></tui-line-clamp>
                }
              </td>
            }
          </tr>
        </tbody>
      </table>
    </cdk-virtual-scroll-viewport>
  </tui-scrollbar>
  <div class="flex justify-end mt-4">
    <button
      (click)="close()"
      class="mr-2"
      appearance="outline"
      tuiButton
      size="m"
    >
      Отмена
    </button>
    <button
      [disabled]="(disabled$ | async)!"
      (click)="submit()"
      tuiButton
      size="m"
    >
      {{ submitText$ | async }}
    </button>
  </div>
</div>
